import { Phone, Sparkles, Banknote } from 'lucide-react';

const MobileCTA = () => {
  const goToDevis = (tab) => {
    const element = document.querySelector('#devis');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    window.dispatchEvent(new CustomEvent('allorep:open-devis-tab', { detail: tab }));
  };

  return (
    <div className="mobile-sticky-cta lg:hidden" data-testid="mobile-sticky-cta">
      <div className="flex gap-2 w-full">
        <button
          onClick={() => goToDevis('repair')}
          className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/30 active:scale-95 transition-all text-sm"
          data-testid="mobile-cta-btn"
        >
          <Sparkles size={16} strokeWidth={2.4} />
          Devis
        </button>
        <button
          onClick={() => goToDevis('buyback')}
          className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-emerald-500 to-green-600 shadow-lg shadow-emerald-500/30 active:scale-95 transition-all text-sm"
          data-testid="mobile-buyback-btn"
        >
          <Banknote size={16} strokeWidth={2.4} />
          Rachat
        </button>
        <a
          href="tel:+33983820754"
          className="inline-flex items-center justify-center px-4 rounded-xl font-semibold text-white bg-gradient-to-r from-cyan-500 to-teal-600 shadow-lg shadow-cyan-500/30 active:scale-95 transition-all"
          data-testid="mobile-call-btn"
          aria-label="Appeler la boutique"
        >
          <Phone size={18} strokeWidth={2.4} />
        </a>
      </div>
    </div>
  );
};

export default MobileCTA;
